import { useAtom, useAtomValue } from "jotai"
import { Controls } from "./Controls"
import { currentAdjustmentsAtom } from "@/store/store-history"
import { editingDisabledAtom } from "@/store/app-state"
import { currentPhotoAtom } from "@/store/photo/photos-state"
import { getDefaultAdjustments } from "@/core/adjustments"

export const AdjustmentsPanel = () => {
	const [editingDisabled] = useAtom(editingDisabledAtom)
	const [adjustments] = useAtom(currentAdjustmentsAtom)
	const currentPhoto = useAtomValue(currentPhotoAtom)

	return (
		<Controls
			disabled={editingDisabled}
			adjustments={currentPhoto ? adjustments : getDefaultAdjustments()}
		/>
	)
}
